export default __webpack_public_path__ + "static/media/duilio.b95052dd.png";